import { useI18n } from 'vue-i18n';
import { $api } from './useApi';
import type { ContactData, ContactFormData } from '@/models/contact';
import { useGoogleRecaptcha } from '@/composables/useGoogleRecaptcha';

export const useContact = async () => {
  const { locale } = useI18n();

  const { executeRecaptcha } = useGoogleRecaptcha();

  const { data } = await useAsyncData(`contact-data-${locale}`, async () => {
    return await $api<ContactData>('/contact-section');
  });

  const contactData = computed<ContactData | undefined>(() => data.value);

  const saveContact = async (data: ContactFormData) => {
    if (data.context) {
      try {
        const { recaptchaData } = await executeRecaptcha('contact');

        await $api<ContactFormData>('/contact-form/save', {
          method: 'POST',
          body: {
            name: data.name,
            email: data.email,
            companyName: data.companyName,
            phone: data.phone,
            vatNumber: data.vatNumber || null,
            zipCode: data.zipCode || null,
            city: data.city || null,
            address: data.address || null,
            comment: data.comment || null,
            context: data.context || null,
            consentPrivacyPolicy: data.consentPrivacyPolicy,
            consentMarketing: data.consentMarketing || null,
            package: data.package || null,
            ...recaptchaData
          }
        });

        data.resetForm?.call(null);
        (data as any).isSuccess.value = true;
      } catch {
        (data as any).isError.value = true;
      }
    }
  };

  return {
    saveContact,
    contactData
  };
};
